import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { FormateoFechaPara_yyyyMMdd, TratamientoDeParametroParaURI } from '../../Varios';

export const function_VEN_ListasPrecios_Detalles_ValorizarDetalle = async (CodigoListaPrecios, CodigoMoneda, JSONDetalles) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalles_ValorizarDetalle"

    try {
        const resulData = await llamadaAPI_GET("VEN_ListasPrecios_Detalle/ValorizarDetalle/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios) + "/" +
            await TratamientoDeParametroParaURI(CodigoMoneda) + "/" +
            JSONDetalles);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Detalles_CambioDeMoneda = async (JSONDetalles, CodigoMonedaOrigen, CodigoMonedaDestino) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalles_CambioDeMoneda"

    try {
        const resulData = await llamadaAPI_GET("VEN_ListasPrecios_Detalle/CambioDeMoneda/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            JSONDetalles + "/" +
            await TratamientoDeParametroParaURI(CodigoMonedaOrigen) + "/" +
            await TratamientoDeParametroParaURI(CodigoMonedaDestino));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Detalle_Importar = async (CodigoListaPrecios, FechaComienzo,
    ColumnaCodigoArticulo, ColumnaCodigoPresentacion, ColumnaCodigoTamano,
    ColumnaCodigoUnidadMedida, ColumnaImporteNeto, ColumnaImporteIVA, ColumnaImporteTotal, Coleccion) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalle_Importar"

    try {
        const resulData = await llamadaAPI_POST("VEN_ListasPrecios_Detalle/Importar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaComienzo)) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoUnidadMedida) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteNeto) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteIVA) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteTotal),
            Coleccion);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Detalle_Generar_JSON = async (CodigoListaPrecios, CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida,
    Importe, ImporteRecargo, ImporteBonificacion, ImporteIVA, ImporteGanancia,
    FechaComienzo, Porcentaje) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalle_Generar_JSON";

    try {

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoListaPrecios: CodigoListaPrecios,
            CodigoArticulo: CodigoArticulo,
            CodigoPresentacion: CodigoPresentacion,
            CodigoTamano: CodigoTamano,
            CodigoUnidadMedida: CodigoUnidadMedida,
            Importe: Importe,
            ImporteRecargo: ImporteRecargo,
            ImporteBonificacion: ImporteBonificacion,
            ImporteIVA: ImporteIVA,
            ImporteGanancia: ImporteGanancia,
            FechaComienzo: FechaComienzo,
            Porcentaje: Porcentaje
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ListasPrecios_Detalle_Insertar = async (ListaPrecios) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalle_Insertar";

    try {
        const docVentaResult = await llamadaAPI_POST("VEN_ListasPrecios_Detalle/Insertar/",
            ListaPrecios);
        return docVentaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ListasPrecios_Detalle_Modificar = async (ListaPrecios) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalle_Modificar";

    try {
        await llamadaAPI_PUT("VEN_ListasPrecios_Detalle/Modificar/",
            ListaPrecios);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ListasPrecios_Detalle_Eliminar = async (ListaPrecios) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Detalle_Eliminar";

    try {
        await llamadaAPI_DELETE("VEN_ListasPrecios_Detalle/Eliminar/",
            ListaPrecios);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

/*
router.get("/API/VEN_ListasPrecios_Detalle/Leer/:CodigoCompania/:CodigoEmpresa/:CodigoPlanta/:CodigoListaPrecios/:FechaComienzo/:CodigoArticulo/:CodigoPresentacion/:CodigoTamano/:CodigoUnidadMedida", VEN_ListasPrecios_Detalle_Leer)
//router.get("/API/VEN_ListasPrecios_Detalle/LeerConOpcionTodos/:CodigoCompania/:CodigoEmpresa/:CodigoPlanta/:CodigoListaPrecios/:FechaComienzo/:CodigoArticulo/:CodigoPresentacion/:CodigoTamano/:CodigoUnidadMedida", VEN_ListasPrecios_Detalle_LeerConOpcionTODOS)
*/